import React from "react";
import { Box, Typography, Grid, IconButton } from "@mui/material";
import { Instagram, LinkedIn, Email } from "@mui/icons-material";
import logo from "../assets/logo2.png";
import { arcStudiozAddress } from "../assets/contents";

const Footer = () => {
  return (
    <Box
      sx={{
        bgcolor: "#fff",
        color: "#333",
        fontFamily: "Montserrat, serif",
        borderTop: "1px solid #cbb278",
        pt: 6,
        pb: 2,
      }}
    >
      <Grid
        container
        spacing={4}
        sx={{
          maxWidth: "1200px",
          minWidth: "300px",
          mx: "auto",
          px: 4,
          borderBottom: "1px solid #cbb278",
          pb: 3,
          alignItems: "flex-start",
        }}
      >
        {/* LEFT SIDE: Logo + Address */}
        <Grid item xs={12} md={8} sx={{ textAlign: "center" }}>
          <Box
            component="img"
            src={logo}
            alt="ARCSTUDIOZ Logo"
            sx={{ width: 180, mb: 2 }}
          />
          <Typography
            sx={{
              color: "#8c7b5f",
              fontSize: "15px",
              lineHeight: 1.8,
              maxWidth: "600px",
              mx: "auto",
            }}
          >
            {arcStudiozAddress}
          </Typography>

          {/* Social Icons */}
          <Box sx={{ mt: 4 }}>
            <IconButton
              href="#"
              sx={{ color: "#b2925a", mx: 1, "&:hover": { color: "#000" } }}
            >
              <Instagram fontSize="medium" />
            </IconButton>
            <IconButton
              href="#"
              sx={{ color: "#b2925a", mx: 1, "&:hover": { color: "#000" } }}
            >
              <LinkedIn fontSize="medium" />
            </IconButton>
            <IconButton
              href="info@arcstudioz.com"
              sx={{ color: "#b2925a", mx: 1, "&:hover": { color: "#000" } }}
            >
              <Email fontSize="medium" />
            </IconButton>
          </Box>
        </Grid>

        {/* RIGHT SIDE: Pages */}
        <Grid
          item
          md={4}
          sx={{
            textAlign: { md: "left" },
            display: { xs: "none", md: "block" },
          }}
        >
          <Typography
            sx={{
              fontSize: "22px",
              fontWeight: 600,
              color: "#000",
              fontFamily: "Playfair Display, serif",
              mb: 2,
            }}
          >
            Pages
          </Typography>
          {["HOME", "ABOUT", "OUR PROJECTS", "BLOGS", "CONTACT"].map(
            (page, index) => (
              <Typography
                key={index}
                sx={{
                  fontSize: "16px",
                  color: "#000",
                  lineHeight: 2,
                  cursor: "pointer",
                  "&:hover": { color: "#b2925a" },
                }}
              >
                {page}
              </Typography>
            )
          )}
        </Grid>
        <Grid
          item
          size={12}
          sx={{
            textAlign: { xs: "center" },
            display: { xs: "block", md: "none" },
          }}
        >
          <Typography
            sx={{
              fontSize: "22px",
              fontWeight: 600,
              color: "#000",
              fontFamily: "Playfair Display, serif",
              mb: 2,
            }}
          >
            Pages
          </Typography>
          {["HOME", "ABOUT", "OUR PROJECTS", "BLOGS", "CONTACT"].map(
            (page, index) => (
              <Typography
                key={index}
                sx={{
                  fontSize: "16px",
                  color: "#000",
                  lineHeight: 2,
                  cursor: "pointer",
                  "&:hover": { color: "#b2925a" },
                }}
              >
                {page}
              </Typography>
            )
          )}
        </Grid>
      </Grid>

      {/* COPYRIGHT SECTION */}
      <Box
        sx={{
          textAlign: "center",
          color: "#000",
          pt: 3,
          fontSize: "14px",
        }}
      >
        <Typography
          sx={{
            mb: 1,
            color: "#000",
            fontFamily: "Montserrat, sans-serif",
            fontSize: "14px",
          }}
        >
          © ARCSTUDIOZ 2025. All Rights Reserved.
        </Typography>
        {/* <Typography
          sx={{
            color: "#000",
            fontFamily: "Montserrat, sans-serif",
            fontSize: "14px",
          }}
        >
          Designed by Independent Creators Collective and developed by Ideamagix.
        </Typography> */}
      </Box>
    </Box>
  );
};

export default Footer;
